var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductHotels = function SvgProductHotels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3322 19.9999H15.333V21.9999H2.66637C2.29818 21.9999 1.99971 21.7014 1.99971 21.3332V19.9999H5.99888V21.9998H11.3322V19.9999Z",
    fill: "#BEF7A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 2C14.4376 2 15.333 2.89543 15.333 3.99999V20H11.3322V18C11.3322 17.2636 10.7352 16.6666 9.99887 16.6666H7.33221C6.59583 16.6666 5.99888 17.2636 5.99888 18V20H1.99971V3.99999C1.99971 2.89543 2.89514 2 3.9997 2H13.333Z",
    fill: "#59CF1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33496 10.6668C7.33496 10.2986 7.03648 10.0001 6.6683 10.0001H5.33497C4.96678 10.0001 4.6683 10.2986 4.6683 10.6668V12.0001C4.6683 12.3683 4.96678 12.6668 5.33497 12.6668H6.6683C7.03648 12.6668 7.33496 12.3683 7.33496 12.0001V10.6668Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 5.33341C12.668 4.96522 12.3695 4.66675 12.0013 4.66675H10.668C10.2998 4.66675 10.0013 4.96522 10.0013 5.33341V6.66674C10.0013 7.03493 10.2998 7.33341 10.668 7.33341H12.0013C12.3695 7.33341 12.668 7.03493 12.668 6.66674V5.33341Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33496 5.33341C7.33496 4.96522 7.03648 4.66675 6.6683 4.66675H5.33497C4.96678 4.66675 4.6683 4.96522 4.6683 5.33341V6.66674C4.6683 7.03493 4.96678 7.33341 5.33497 7.33341H6.6683C7.03648 7.33341 7.33496 7.03493 7.33496 6.66674V5.33341Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 10.6668C12.668 10.2986 12.3695 10.0001 12.0013 10.0001H10.668C10.2998 10.0001 10.0013 10.2986 10.0013 10.6668V12.0001C10.0013 12.3683 10.2998 12.6668 10.668 12.6668H12.0013C12.3695 12.6668 12.668 12.3683 12.668 12.0001V10.6668Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 9.33325C22.002 8.22868 21.1065 7.33325 20.002 7.33325H15.3353V19.9999H22.002V9.33325Z",
    fill: "#44B50C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 20H15.3353V22H21.3353C21.7035 22 22.002 21.7015 22.002 21.3333V20Z",
    fill: "#BEF7A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039 10.6667C20.0039 10.2985 19.7054 10 19.3372 10H18.0039C17.6357 10 17.3372 10.2985 17.3372 10.6667V12C17.3372 12.3682 17.6357 12.6667 18.0039 12.6667H19.3372C19.7054 12.6667 20.0039 12.3682 20.0039 12V10.6667Z",
    fill: "white"
  })));
};
export default SvgProductHotels;